import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  collapsible_container: {
    display: "flex",
    position: "absolute",
    top: "100",
    left: "0",
    height: "80px",
    width: "100%",
    // direction: 'ltr',
  },
  collapsible_box: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
  },
  headerSlider: {
    position: "relative",
    top: "52px",
    left: 0,
    [theme.breakpoints.down("desktop")]: {
      // top: '124px',
    },
  },
  collapse_open: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 20px",
    backgroundColor: "#fff",
    width: "100%",
    position: "absolute",
    zIndex: 10,
  },
}));

export default useStyles;
